export default function (state: any = {}, _action: any) {
  return state
}
